import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import type { IUser } from "api/user/types";
import { RootState } from "store";

export type AuthUser = Omit<Partial<IUser>, "id" | "token" | "accessToken"> & {
	id?: string;
	permissions?: string[];
};

export interface IAboutStore {
	dataSignUp: any;
	verifyToken: string;
	userData: AuthUser;
}

const initialState: IAboutStore = {
	dataSignUp: null,
	userData: {},
	verifyToken: "",
};

export const investorSlice = createSlice({
	name: "investor",
	initialState,
	reducers: {
		setDataSignUp: (state, action: PayloadAction<any | null>) => {
			return {
				...state,
				dataSignUp: action.payload,
			};
		},
		setVerifyToken: (state, action: PayloadAction<string>) => {
			return {
				...state,
				verifyToken: action.payload,
			};
		},
		setUser: (state, action: PayloadAction<AuthUser>) => {
			return {
				...state,
				userData: action.payload,
			};
		},
		clearUser: (state) => {
			state.userData = {};
		},
	},
});

export const getDataSignUp = (state: RootState) => state.investor.dataSignUp;
export const getUser = (state: RootState) => state.investor.userData;

export const getVerifyToken = (state: RootState) => state.investor.verifyToken;

export const { setDataSignUp, setVerifyToken, setUser, clearUser } = investorSlice.actions;

export default investorSlice.reducer;
